import { Card } from '@/shared/components/index.ts';
import { cn } from '@/shared/utils';
import type { ReactNode } from 'react';

export type InfoDataGridData = { key: string; value?: string | ReactNode }[];

export function InfoDataTable({
  data,
  className,
}: {
  data: InfoDataGridData;
  className?: string;
}) {
  return (
    <Card variant="details" className={cn(className)}>
      {data.map(item => {
        return (
          <div
            key={item.key}
            className="grid grid-cols-[10rem_1fr] gap-[2.4rem]">
            <div className="text-muted-foreground p4">{item.key}</div>
            <div className="headline4 break-all">{item.value}</div>
          </div>
        );
      })}
    </Card>
  );
}
